class MainHeader extends HTMLElement {
  constructor() {
    super();
    this.headerSearchInputs = document.querySelectorAll(
      ".header__search-form input.ss-search-input"
    );
  }

  connectedCallback() {
    this.initHeaderSearchInputController();
    this.initHeaderAnnouncementBarController();
    this.watchForClassChange();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  // Header search state control
  initHeaderSearchInputController() {
    document
      .querySelector(".header__search-form .input-search__icon")
      .addEventListener("click", (e) => {
        e.preventDefault();
        e.currentTarget
          .closest(".header__search-form input.ss-search-input")
          ?.focus();
      });

    this.headerSearchInputs.forEach((input) => {
      let initialPlaceholder = input.getAttribute("placeholder");
      input.addEventListener("focusout", () => {
        input.setAttribute("placeholder", initialPlaceholder);
        if (input.value.length == 0) {
          input.parentElement
            .querySelector(".page-search-form__button")
            ?.classList.remove("active");
        }
      });
      input.addEventListener("focusin", () => {
        input.setAttribute("placeholder", "What are you looking for?");
        input.parentElement
          .querySelector(".page-search-form__button")
          ?.classList.add("active");
      });
    });
  }
  // Header announcement bar control
  initHeaderAnnouncementBarController() {
    let headerBar = document.querySelector(".header__bar");
    let barStatus = sessionStorage.getItem("hideAnnouncementBar");
    let closeBarButton = document.querySelector("#close-bar");
    if (!headerBar) return;
    if (barStatus === null) {
      headerBar.style.display = "block";
      document.querySelector(".fixed-full-width")?.classList.add("extended");
    }
    closeBarButton?.addEventListener("click", () => {
      sessionStorage.setItem("hideAnnouncementBar", "true");
      headerBar.style.display = "none";
      document.querySelector(".fixed-full-width")?.classList.remove("extended");
    });
  }
  watchForClassChange() {
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "class") {
          if (mutation.target.classList.contains("ss-ac-visible")) {
            document.documentElement.classList.add("disabled-scroll");
            document.body.classList.add("disabled-scroll");
          } else {
            document.documentElement.classList.remove("disabled-scroll");
            document.body.classList.remove("disabled-scroll");
          }
        }
      });
    });

    // Specify which mutations to observe (in this case, attribute changes)
    const config = { attributes: true, attributeFilter: ["class"] };
    this.headerSearchInputs.forEach((input) => {
      this.observer.observe(input, config);
    });
  }
}

customElements.define("main-header", MainHeader);
